export default {
    /** File Control */
    file_control: {
        heading: 'DATEIÜBERSICHT',
        info_text: `
            <ul class="file-control-info-text">
                <li><span class="bold">Wählen Sie eine Datei aus oder ziehen Sie sie in den Container</span></li>
                <li>Die Dateien müssen vom Typ <span class="bold">'log'</span>, <span class="bold">'jou'</span>, <span class="bold">'json'</span> oder <span class="bold">'zip'</span> sein</li>
                <li>Eine Datei darf maximal 30MB groß sein</li>
                <li>Log-Dateien dürfen nur 8 Ziffern im Namen enthalten, z.B. 20250521.log oder 21052025e.log</li>
                <li>Nach dem Klicken auf ‘<span class="bold">UPLOAD</span>’ werden die ausgewählten Dateien in einen Azure Blob-Container hochgeladen, wo sie analysiert werden</li>
                <li>Sie können <span class="bold">einzelne Dateien</span> aus der Liste auswählen, um die angezeigten Ergebnisse zu reduzieren</li>
                <li>Eine <span class="bold">Übersicht</span> finden Sie links unten, während die <span class="bold">detaillierten Ergebnisse</span> rechts angezeigt werden</li>
                <li>Sie können die Ergebnisse als 'jou'-Datei links unten herunterladen</li>
            </ul>
            `,
        drag_and_drop: `Drag & Drop oder klicken<br>um Datei auszuwählen`,
        file_selected_click_add: `{count} Datei ausgewählt (klicken oder Drag & Drop,<br>um weitere hinzuzufügen)`,
        files_selected_click_add: `{count} Dateien ausgewählt (klicken oder Drag & Drop,<br>um weitere hinzuzufügen)`,
        file_selected_reset: `{count} Datei ausgewählt (zurücksetzen, um<br>neue Dateien hinzuzufügen)`,
        files_selected_reset: `{count} Dateien ausgewählt (zurücksetzen,<br>um neue Dateien hinzuzufügen)`,
        reset_files: 'DATEIEN ZURÜCKSETZEN',
        reset_page: 'SEITE ZURÜCKSETZEN',
        upload: 'HOCHLADEN',
        uploaded_files: 'Hochgeladene Dateien',
        remove_selection: 'Auswahl entfernen',
        threshold_input: `
            <p style="margin:0 10px 6px; font-size:16px; font-weight:bold">MAXMINALE ANTWORTZEIT</p>
            <p style="margin:0 10px">Maximale erlaubte Zeitdauer zwischen Checkin und Checkout von Transaktionen in Sekunden.</p>
            <p style="margin:0 10px">Leer lassen um Standard von 10s zu nehmen.</p>
            `
    },
    
    /** Result View */
    result_view: {
        journal: 'JOURNAL ANALYSE',
        log: 'LOG ANALYSE',
        cases: 'BUSINESS CASES',
        tax: 'STEUERGRUPPEN',
        version: 'VERSIONSVERLAUF',
        responsetimeanalysis: 'REQUEST DAUER',
        please_upload_file: 'Bitte eine Datei auf der linken Seite hochladen.',
        copy: 'Kopieren',
        copied: 'Inhalt in Zwischenablage kopiert',
        journal_analysis: {
            no_errors: 'Keine Journalfehler gefunden',
            no_errors_selected: 'Keine Journalfehler in der ausgewählten Datei gefunden',
            errorcode: 'Errorcode',
            tl_tt_tn: 'TL | TT | TN',
            sq: 'SQ',
            date_time: 'Datum, Uhrzeit',
            amount: 'Anzahl',
            message: 'Nachricht',
            clear_btn: 'Auswahl löschen',
            searchbar_placeholder: 'Nach Nachricht suchen ...',
            datepicker_placeholder: 'Nach Datum filtern',
        },
        log_analysis: {
            no_errors: 'Keine Logfehler gefunden',
            no_errors_selected: 'Keine Logfehler in der ausgewählten Datei gefunden',
            errorcode: 'Errorcode',
            date_time: 'Datum, Uhrzeit',
            amount: 'Anzahl',
            message: 'Nachricht',
            clear_btn: 'Auswahl löschen',
            searchbar_placeholder: 'Nach Nachricht suchen ...',
            datepicker_placeholder: 'Nach Datum filtern',
        },
        business_cases: {
            type: 'Typ',
            amount: 'Anzahl'
        },
        tax_groups: {
            no_data: 'Keine Daten gefunden',
            no_data_selected: 'Keine Daten in der ausgewählten Datei gefunden',
            taxg: 'Steuergruppe',
            percent: '%',
            amount: 'Brutto',
            tax: 'Steuern',
            net: 'Netto',
        },
        version_history: {
            no_data: 'Keine Daten gefunden',
            no_data_selected: 'Keine Daten in der ausgewählten Datei gefunden',
            efr_version: 'EFR Version',
            countries: 'Länder',
            date: 'Datum',
            time: 'Uhrzeit',
        },
        response_time_analysis: {
            no_errors: 'Keine Daten gefunden',
            no_errors_selected: 'Keine Daten in der ausgewählten Datei gefunden',
            datepicker_placeholder: 'Nach Datum filtern',
            day_file: 'Tag / Datei',
            avg: 'Durchschnitt',
            topten: '10 Längsten',
            unresolved: 'Ungelöst',
            exceeded: 'Schwelle überschritten'
        }
    },

    /** General Information */
    summary_control: {
        general_information: 'ALLGEMEINE INFORMATIONEN',
        records_analyzed: 'Analysierte Datensätze',
        total_amount: 'Gesamtbetrag',
        journal_errors: 'Journal Fehler',
        log_errors: 'Log Fehler',
        save_text: 'ERGEBNIS ALS JOURNAL SPEICHERN'
    },

    fileUpload: {
        fileSizeSingleError: "Größe der Datei {file} überschreitet das Limit von 30MB!",
        fileSizeMultipleError: "Größe der Dateien {files} überschreiten das Limit von 30MB!",

        logFileNameSingleError: "Dateiname {file} entspricht nicht dem erwarteten Format!",
        logFileNameMultipleError: "Dateinamen {files} entsprechen nicht dem erwarteten Format!",
        logFileNameHint: "Erwartet: YYYYMMDD.log oder YYYYMMDDe.log. Dateien mit anderen Namen werden vom Analyzer übersprungen. Bitte umbenennen und erneut hinzufügen.",

        noFilesAccepted: "Der Upload enthielt keine Datei, die der Analyzer verarbeiten kann.",
        unreadableResponse: "Die Antwort des Servers konnte nicht gelesen werden (möglicherweise abgeschnitten). Bitte erneut versuchen.",
        uploadRejected: "Der Upload wurde abgelehnt (HTTP {status}): {message}",
        uploadFailed: "Der Upload ist fehlgeschlagen: {message}",
        noFileToAnalyze: "Keine Datei zum Analysieren!",

        analyzeFailed: "{file} konnte nicht analysiert werden: {reason}",
        analyzeFailedAll: "Keine der hochgeladenen Dateien konnte analysiert werden.",
        reasonHttp: "der Server hat mit HTTP {status} geantwortet",
        reasonUnreadable: "die Antwort des Servers konnte nicht gelesen werden (möglicherweise abgeschnitten)",
        reasonNetwork: "Netzwerkfehler ({message})"
    }
}